<template>
    <div class="main mt15">
        <div class="banner" @click="toBuy">
            <img src="../../../images/safeProductionTab.jpg" alt="" ref="info">
            <div class="banner-container">
            </div>
        </div>
        <div class="tabs" ref="tabs">
            <div class="tabs-container" :class="{fixed:fixed}">
                <Tabs :value="tabName" @on-click="tabChange">
                    <TabPane label="产品特色" name="info"></TabPane>
                    <TabPane label="保障方案" name="case"></TabPane>
                    <TabPane label="常见问题" name="question"></TabPane>
                    <TabPane label="理赔流程" name="claim"></TabPane>
                </Tabs>
            </div>
        </div>
        <div class="detail">
            <div class="detail-title">产品特色</div>
            <div class="detail-main">
                <div style="color: red;">咨询电话：187 6642 6120</div>
                <div class="detail-main-text">
                    <b>（一）保险内容：</b><br />
                    1、保险内涵。建筑施工领域安责险是指保险机构对我市行政区域内投保的工程项目生产安全事故造成的人员伤亡和有关经济损失予以赔偿，并且提供安全事故预防服务的商业保险。<br />
                    2、保障范围。保障范围包括从业人员、第三者责任及其他相关费用等部分，具体包括：从业人员保障（死亡赔偿金、伤残赔偿金、医疗费用）；第三者责任（第三者的人身伤亡或财产损失）；其他相关费用（抢险救援费用、事故鉴定、法律诉讼费用等）。<br />
                    3、保险期限。保险期限应覆盖工程项目开工之日到工程竣工验收合格日。提前竣工的，保险责任自行终止。因延长工期的，应当办理保险顺延手续。鉴于工程建设项目施工工艺流程中各工种调动频繁、用工流动性大，投保应实行不记名和不计人数的方式。<br />
                    4、保险费用。按照承保机构所公布的保险费率执行，并根据参保单位的安全生产状况、安全生产标准化开展情况实行浮动机制。安责险的保费支出列入工程造价。<br />
                   <b ref="case">（二）参保要求：</b><br />
                    1、从2021年6月1日起，本市行政区域内新开工的新建、改建、扩建房屋建筑与市政基础设施工程项目均由相应的建筑施工企业以项目为单位办理安责险。<br />
                    2、起始日前开工的工程项目，建筑施工企业依照有关法律法规和文件规定已投保与安责险属性相同的责任保险的，鼓励将其调整为安责险，纳入安责险管理范围。<br />
                    3、安责险的保费由施工总承包企业缴纳，不得以任何方式摊派给从业人员。工程项目中有分包单位的由总承包施工企业统一办理，分包单位合理承担投保费用。
                </div>
            </div>
        </div>
        <div class="detail">
            <div class="detail-title">保障方案</div>
            <div class="detail-main">
                <div class="detail-main-text red">
                    以下为山东省建筑施工行业总包项目建议方案及费率，项目不同略有差异，详情请咨询服务人员。
                </div>
                <div class="center">
                    <table class="productDetail-table">
                        <thead>
                            <tr>
                                <th>保障范围</th>
                                <th>方案一</th>
                                <th>方案二</th>
                                <th>方案三</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="hoverTr">
                                <td>从业人员每人死亡伤残赔偿责任</td>
                                <td>50万</td>
                                <td>70万</td>
                                <td>90万</td>
                            </tr>
                            <tr class="hoverTr">
                                <td>从业人员每人医疗费用赔偿责任</td>
                                <td>10万</td>
                                <td>10万</td>
                                <td>10万</td>
                            </tr>
                            <tr class="hoverTr">
                                <td>第三者每人人身伤亡赔偿责任</td>
                                <td>50万</td>
                                <td>70万</td>
                                <td>90万</td>
                            </tr>
                            <tr class="hoverTr">
                                <td>第三者每人医疗费用赔偿责任</td>
                                <td>10万</td>
                                <td>10万</td>
                                <td>10万</td>
                            </tr>
                            <tr class="hoverTr">
                                <td>第三者财产损失</td>
                                <td>10万</td>
                                <td>10万</td>
                                <td>10万</td>
                            </tr>
                            <tr class="hoverTr">
                                <td>综合费用责任限额</td>
                                <td>100万</td>
                                <td>200万</td>
                                <td>300万</td>
                            </tr>
                            <tr class="hoverTr">
                                <td>费率（‰）</td>
                                <td>0.65</td>
                                <td>1.4</td>
                                <td>1.7</td>
                            </tr>
                            <tr class="hoverTr">
                                <td>工程期限</td>
                                <td colspan="3">0-36 个月(含)</td>
                            </tr>
                            <tr class="hoverTr" ref="question">
                                <td>保单每次事故责任限额</td>
                                <td>1700万</td>
                                <td>3200万</td>
                                <td>4300万</td>
                            </tr>
                            <tr class="hoverTr">
                                <td>保单累计责任限额</td>
                                <td>2100万</td>
                                <td>4200万</td>
                                <td>6300万</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="detail">
            <div class="detail-title">常见问题</div>
            <div class="detail-main">
                <div class="detail-main-text">
                    <p><b>1、投保人、被保险人是谁？</b></p>
                    <p>
                        答：投保人：施工总承包单位或建筑建设单位直接发包的承包单位<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;被保险人：通常是企业，可以同投保人
                    </p>
                    <p><b>2、如何获取精准报价？</b></p>
                    <p>答：提供营业执照、施工合同、工程量清单后获取精准保险方案，并由服务人员协助完成投保。</p>
                    <p><b>3、企业为什么要投保建筑施工安全生产责任险？</b></p>
                    <p ref="claim">答：①青岛市住建相关政策要求：从2021年6月1日起，本市行政区域内新开工的新建、改建、扩建房屋建筑与市政基础设施工程项目均由相应的建筑施工企业以项目为单位办理安责险。<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;②安全生产责任保险以“安全+保险+服务”的模式兼具商业保险的风险专业化控制和社会保障功能，可有效构建完善建筑施工安全生产风险防范长效机制。</p>
                    <p><b>4、保险到期后工程尚未完工，保单可否延期？</b></p>
                    <p>答：保险期限应覆盖工程项目开工之日到工程竣工验收合格日。提前竣工的，保险责任自行终止。因延长工期的，应当办理保险顺延手续。
                    </p>
                </div>
            </div>
        </div>
        <div class="detail">
            <div class="detail-title">理赔流程</div>
            <Steps class="mt30 step-con">
                <Step 
                    title="拨打报案电话" 
                    status="process"
                    content="请立即拨打报案电话18766426120进行报案，详细说明出险情况。被保险人应在48小时内及时报案。"
                ></Step>
                <Step 
                    title="提交索赔材料" 
                    status="process"
                    content="报案后我们会告知您所需的材料，请按照要求待治疗结束后提供资料。"
                ></Step>
                <Step 
                    title="领取赔款" 
                    status="process"
                    content="资料收到后，保险公司核定损失，确定赔偿金额，按照约定赔付方式支付赔款。"
                ></Step>
            </Steps>
        </div>
        
        <div class="detail allDet detail-main-text">
             <p>
                <b>请添加以下微信进行询价</b>
             </p>
            <img src="../../../images/code.png"  style="width: 20%;margin-top: 15px;" alt="">
        </div>
    </div>
</template>
<script>
    export default {
        data () {
            return {
                rules: {
                    code: [{ required: true, message: '请输入88码', trigger: 'blur' }]
                },
                tabName: 'info',
                fixed: false,
                renewId: this.$route.query.renewId || '' //续保，上一保单id
            }
        },
        mounted () {
            this.$nextTick(() => {
                window.addEventListener("scroll", this.handleScroll);
            })
        },
        beforeDestroy () {
            window.removeEventListener('scroll', this.handleScroll)
        },
        methods: {
            // 立即购买
            toBuy () {
                let url = '/haierProduct.html#/customized-employer-liability/fillin';
                if (this.renewId) url += `/${this.renewId}?renew=1&productCode=QYTTGZZRXPCNEW`
                else url += `?productCode=QYTTGZZRXPCNEW`
                location.href = url
            },
            // tab切换
            tabChange (val) {
                this.$refs[val].scrollIntoView({
                    behavior: "smooth",  // 平滑过渡
                    block: "start"
                })
            },
            // 定位到伤残费率表位置
            toSC () {
                this.$refs['SC'].scrollIntoView({
                    behavior: "smooth",  // 平滑过渡
                })
            },
            // 监听滚动
            handleScroll () {
                //获取滚动时的高度
                let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
                if (scrollTop > this.$refs.tabs.offsetTop) {
                    this.fixed = true;
                } else {
                    this.fixed = false;
                }
            }
        }
    }
</script>
<style scoped lang="less">
    .main {
        margin-bottom: 30px;
    }

    .pb50 {
        padding-bottom: 50px;
    }

    .pt40 {
        padding-top: 40px;
    }

    .banner-container {
        position: absolute;
        font-size: 14px;
        text-align: center;
        width: 510px;
        top: 80px;
        left: 0;
        right: 0;
        color: #fff;

        .notes {
            margin-top: 10px;
        }

        &-title {
            font-size: 32px;
            color: #333;
        }

        &-case {
            font-size: 24px;
            line-height: 2;
            color: #318af0;
        }

        &-sub {
            font-size: 14px;
            color: #555;
            margin-top: 30px;

            span {
                margin-right: 5px;
            }
        }

        &-desc {
            font-size: 18px;
        }

        &-input {
            width: 300px;
            margin: 20px auto 0;
        }

        &-btn {
            margin-top: 30px;

            a {
                width: 240px;
            }
        }
    }

    .detail-title {
        font-size: 30px;
    }

    .detail-main {
        .center {
            font-size: 0;
        }

        &-title,
        &-text {
            // padding-left: 20px;
        }

        &-title {
            font-size: 18px;
        }

        &-text {
            line-height: 2;
        }
    }

    .tabs {
        display: block;
        height: 46px;

        &-container {
            padding: 10px 10px 0;
            background: #fff;
            height: 46px;
            overflow: hidden;
            position: relative;

            &-form {
                position: absolute;
                right: 10px;
                bottom: 5px;

                button {
                    display: inline-block;
                }
            }
        }

        .fixed {
            position: fixed;
            top: 100px;
            left: 0;
            right: 0;
            margin: auto;
            width: 1200px;
        }
    }

    .productDetail-table.sm {
        font-size: 13px;

        .fs16 {
            font-size: 16px;
        }

        td {
            padding: 8px;
        }
    }

    .hoverTr:hover {
        color: #fff;

        td {
            background: #77adf5;
        }

        .hoverDisabled {
            background: #fafafa;
            color: #333;
        }
    }

    .importantText {
        color: #77adf5;
    }

    .tit {
        font-size: 18px;
        margin: 10px 0;
    }
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/customizedEmployerLiability/productList/safeProduction.vue